import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PageTitlesFunc from './PageTitlesFunc';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';


function PageTitles() {
    const history = useLocation();
    let history2 = useHistory();
    let paramsUrl = useLocation();
    
    useEffect(() => {
        let page = (new URLSearchParams(paramsUrl.search)).get("lux-ref");
        let token = localStorage.getItem('token')
        if(page && !token){
            localStorage.setItem('user-afiliate',page);
        }
    }, [])


    useEffect(() => {
        let path = titleData[history.pathname]
        if(path) {
            PageTitlesFunc({
                title : path.title  ,
                description: path.desc ,
                canonical:'https://' + window.location.hostname + history.pathname
            })
        } else {
            // document.title = 'فروشگاه اینترنتی لوکسین لوکس. مرجع خرید کالای لوکس در ایران';
        }
        return () => {
        }
    }, [history]);

    return (null);
}

export default PageTitles;


const titleData = {
    '/': {
        title: 'فروشگاه اینترنتی لوکسین لوکس. مرجع خرید کالای لوکس در ایران',
        desc: 'بهترین های لوکس ایران و جهان در لوکسین لوکس ! خرید کالای لوکس در سطحی جدید با خدماتی خاص و قیمتی رقابتی در اولین بازارچه کالاهای لوکس در ایران',
    },
    '/shops/': {
        title: 'فروشگاه اینترنتی لوکسین لوکس - فروشگاه‌ها',
        desc: 'لیست فروشگاه‌ها',
    },
    '/aboutus/': {
        title: 'لوکسین لوکس - ما را بشناسید',
        desc: 'بهترین های لوکس ایران و جهان در لوکسین لوکس ! خرید کالای لوکس در سطحی جدید با خدماتی خاص و قیمتی رقابتی در اولین بازارچه کالاهای لوکس در ایران',
    },
    '/contactus/': {
        title: 'لوکسین لوکس - ارتباط با ما',
        desc: 'بهترین های لوکس ایران و جهان در لوکسین لوکس ! خرید کالای لوکس در سطحی جدید با خدماتی خاص و قیمتی رقابتی در اولین بازارچه کالاهای لوکس در ایران',
    },
    '/questions/': {
        title: 'لوکسین لوکس - سوالات متداول',
        desc: 'بهترین های لوکس ایران و جهان در لوکسین لوکس ! خرید کالای لوکس در سطحی جدید با خدماتی خاص و قیمتی رقابتی در اولین بازارچه کالاهای لوکس در ایران',
    },
    '/rules/': {
        title: 'لوکسین لوکس - شرایط و قوانین',
        desc: 'بهترین های لوکس ایران و جهان در لوکسین لوکس ! خرید کالای لوکس در سطحی جدید با خدماتی خاص و قیمتی رقابتی در اولین بازارچه کالاهای لوکس در ایران',
    },
    '/singup-seller/': {
        title: 'لوکسین لوکس - ثبت نام فروشنده',
        desc: 'بهترین های لوکس ایران و جهان در لوکسین لوکس ! خرید کالای لوکس در سطحی جدید با خدماتی خاص و قیمتی رقابتی در اولین بازارچه کالاهای لوکس در ایران',
    },
    '/campaign/color-suggestion': {
        title: 'لوکسین لوکس - رنگ موهات رو ما بهت می‌گیم!',
        desc: 'پرسشنامه ما به شما کمک می‌کنه تا رنگ موی مناسب خودتون رو براساس رنگ پوست، رنگ چشم و استایل شخصی‌تون پیدا کنید. چه بخواید جلب توجه کنید، چه بخواید ساده و معمولی باشید، ما طیف وسیعی از گزینه‌ها رو برای شما داریم. همین الان پرسشنامه ما را پاسخ بدید و رنگ موی مناسب خودتون رو کشف کنید؛ رنگ مویی که زیبایی طبیعی شما رو چند برابر می‌کنه.',
    },
}